import { render, staticRenderFns } from "./ReferenceHandler.vue?vue&type=template&id=9b3fd5f8&scoped=true&"
import script from "./ReferenceHandler.vue?vue&type=script&lang=js&"
export * from "./ReferenceHandler.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceHandler.vue?vue&type=style&index=0&id=9b3fd5f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3fd5f8",
  null
  
)

/* custom blocks */
import block0 from "@/translations/ReferenceHandler.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc665095227%2Fsrc%2Ffincraft-app%2Fsrc%2Fcomponents%2Fcommon%2Flexicon%2FLexiconOverlay%2FReferenceHandler.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCard,VMenu})
